import { Link } from 'react-router-dom';
import { Stack, Title, Text, Button } from '@mantine/core';

export default function NotFound() {
  return (
    <Stack align="center" gap="md" py="xl" ta="center">
      <Title order={1}>404</Title>
      <Text c="dimmed">We couldn't find that page.</Text>
      <Button component={Link} to="/">Back to home</Button>
    </Stack>
  );
}
